module.exports = __webpack_public_path__ + "img/curved-rail-vertical-right-top-ties.ce47b1da.png";